/**
 * BBOX manual por provincia para el zoom-on-click.
 * Formato: [[west, south], [east, north]]
 */
const PROVINCE_BOUNDS = {
  'buenos aires': [[-63.5, -40.5], [-56.0, -32.2]],
  catamarca: [[-70.5, -30.5], [-64.8, -25.1]],
  chaco: [[-63.5, -28.2], [-57.8, -24.0]],
  chubut: [[-72.2, -46.2], [-64.1, -41.0]],
  'c.a.b.a.': [[-58.53, -34.72], [-58.33, -34.52]],
  caba: [[-58.53, -34.72], [-58.33, -34.52]],
  'ciudad autonoma de buenos aires': [[-58.53, -34.72], [-58.33, -34.52]],
  'ciudad de buenos aires': [[-58.53, -34.72], [-58.33, -34.52]],
  corrientes: [[-60.1, -30.0], [-55.5, -28.0]],
  cordoba: [[-66.8, -35.2], [-61.7, -29.4]],
  'entre rios': [[-60.9, -34.1], [-57.7, -30.1]],
  formosa: [[-62.4, -26.5], [-57.6, -22.1]],
  jujuy: [[-67.3, -24.7], [-63.7, -21.8]],
  'la pampa': [[-69.2, -39.2], [-62.3, -35.0]],
  'la rioja': [[-70.1, -31.9], [-65.1, -27.7]],
  mendoza: [[-70.6, -37.6], [-66.2, -31.0]],
  misiones: [[-56.2, -28.2], [-53.6, -25.3]],
  neuquen: [[-71.8, -41.2], [-68.1, -35.5]],
  'rio negro': [[-71.9, -42.1], [-62.7, -37.1]],
  salta: [[-68.8, -26.7], [-62.2, -21.8]],
  'san juan': [[-70.7, -32.4], [-66.4, -28.3]],
  'san luis': [[-67.7, -35.8], [-64.9, -31.7]],
  'santa cruz': [[-73.0, -52.4], [-65.5, -45.8]],
  'santa fe': [[-63.5, -34.4], [-58.0, -27.0]],
  'santiago del estero': [[-65.4, -30.5], [-61.5, -25.1]],
  'tierra del fuego': [[-68.8, -55.2], [-64.4, -52.6]],
  tucuman: [[-66.2, -28.2], [-64.6, -25.8]],
};

// Override de zoom máximo al hacer fit por provincia (solo casos puntuales).
const PROVINCE_FIT_MAX_ZOOM_OVERRIDES = {
  'c.a.b.a.': 10.5,
  caba: 10.5,
  'ciudad autonoma de buenos aires': 10.5,
  'ciudad de buenos aires': 10.5,
  'santiago del estero': 9.0,
  'la rioja': 8.0,
  'entre rios': 8.0,
  'santa fe': 6.5,
  'san luis': 6.5,
  'la pampa': 6.5,
  'tierra del fuego': 7.5,
  cordoba: 6.5,
  tucuman: 8.0,
  misiones: 9.0,
  corrientes: 6.5,
  catamarca: 8.0,
  salta: 8.0,
  formosa: 8.0,
  chaco: 9.0,
  jujuy: 10.0,
  neuquen: 8.0,
};

function normalizeProvinceName(name) {
  return String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function getProvinceNameFromProperties(props) {
  if (!props || typeof props !== 'object') return '';
  const candidateKeys = ['province_name', 'name', 'NOMPROV', 'provincia', 'PROVINCIA', 'NAME_1', 'Name'];
  for (const key of candidateKeys) {
    const value = props[key];
    if (typeof value === 'string' && value.trim() !== '') return value.trim();
  }
  return '';
}

export function getProvinceManualBounds(properties) {
  const rawName = getProvinceNameFromProperties(properties);
  if (!rawName) return null;
  const key = normalizeProvinceName(rawName);
  return PROVINCE_BOUNDS[key] || null;
}

export function getProvinceFitMaxZoomOverride(properties) {
  const rawName = getProvinceNameFromProperties(properties);
  if (!rawName) return null;
  const key = normalizeProvinceName(rawName);
  return PROVINCE_FIT_MAX_ZOOM_OVERRIDES[key] ?? null;
}

